import { TransactionEmissionEstimate } from '@lune-climate/lune'
import { SuccessResponseWithMeta } from '@lune-climate/lune/esm/core/SuccessResponse'
import { TransactionEstimateResult } from '@lune-fe/lune-components-lib'
import { FC, RefObject, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { asSuccessResponseWithMeta } from 'endpoints/util'
import { useLuneClient } from 'hooks/useLuneClient'
import useTitle from 'hooks/useTitle'
import { ResultsWrapper } from 'views/CalculateEmissions/index'

const EverydayPurchasesResults: FC<{ scrollRef: RefObject<HTMLDivElement> }> = ({ scrollRef }) => {
    useTitle('Everyday Purchases Results')
    const { id } = useParams<{ id: string }>()
    const [estimate, setEstimate] = useState<SuccessResponseWithMeta<TransactionEmissionEstimate>>()
    const luneClient = useLuneClient()

    useEffect(() => {
        if (id) {
            luneClient.getTransactionEstimate(id).then((res) => {
                if (res.isOk()) {
                    const e = asSuccessResponseWithMeta(res.value)
                    setEstimate(e)
                }
            })
        }
    }, [id, luneClient])

    return (
        <ResultsWrapper scrollRef={scrollRef} calculatedAmount={estimate?.mass.amount || ''}>
            {estimate && (
                <TransactionEstimateResult estimate={estimate} enableEmissionFactorLink={true} />
            )}
        </ResultsWrapper>
    )
}

export default EverydayPurchasesResults
